import React, { createContext, type ReactNode, useContext } from 'react';

import invariant from 'tiny-invariant';

import { CustomizationDataShapes } from '../../common/types';

export const SideNavContext = createContext<CustomizationDataShapes | null>(null);

type SideNavDataProviderProps = {
	children: ReactNode;
	value: CustomizationDataShapes;
};

// todo: Merge this with the outer context for customization data. We only need one.
export function SideNavDataProvider({ children, value }: SideNavDataProviderProps) {
	return <SideNavContext.Provider value={value}>{children}</SideNavContext.Provider>;
}

export const useSideNavData = () => {
	const customizationDataShapes = useContext(SideNavContext);

	invariant(
		customizationDataShapes,
		'useSideNavData must be used inside an initialized SideNavDataProvider',
	);

	return customizationDataShapes;
};
